module.exports = __webpack_public_path__ + "static/media/island.c49179e6.svg";